import { MetaType } from "graphql/generated/graphql";
import { getTypedLowerCase } from "utils/service";
import { metaTypeList } from "utils/utils";
import { actions as metaTypeActions } from "./MetaType.actions";

interface IdentityTypeAPI {
    [key: string]: { [key: string]: MetaType };
}

const metaTypeQuery = (metaType: MetaType) => `query ${metaType}($by: String, $id: String!) {
    ${metaType}(by: $by, id: $id) {
        ${metaType}_type
    }
}`;

export const fetchMetaType = (
    dispatch,
    selector: string,
    by: "id" | "name",
    metaType: MetaType
): Promise<IdentityTypeAPI> =>
    new Promise((resolve, reject) => {
        dispatch({
            promise: { resolve, reject },
            type: metaTypeActions.START_FETCH_META_TYPE,
            params: {
                query: metaTypeQuery(metaType),
                variables: {
                    id: selector,
                    by,
                },
                allow_deleted: true,
            },
        });
    });

export const metaTypes = metaTypeList.map((type) => getTypedLowerCase(type));
